import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notify-page',
  templateUrl: './notify-page.component.html',
  styleUrls: ['./notify-page.component.scss']
})
export class NotifyPageComponent implements OnInit {
  supportPhoneNumber = '087 012 5461';
  constructor() { }

  ngOnInit(): void {
  }

}
